import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface OtherDescriptionProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OtherDescription: React.FC<OtherDescriptionProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [otherDescription, set_otherDescription] = useBudgetConstructionField<string>(
        propertyGuid,
        (b) => (b.values?.['Interior Finishes']?.['Other, Describe']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Other, Describe': [v, b.values?.['Interior Finishes']?.['Other, Describe']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Other - Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={otherDescription}
                />
            ) : (
                <TextBox
                    value={otherDescription}
                    onChange={(value) => set_otherDescription(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
